export const NIVO_SLIDER_RECEIVED = "nivo_slider_received";